


import { computed, ComputedRef, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import config from "@/config";
import BasePageTwoColumn from "@/components/BasePageTwoColumn.vue";
import WrapperCheckAuthorities from "@/components/WrapperCheckAuthorities.vue";
import WrapperCheckRoleAndAuthorities from "@/components/WrapperCheckRoleAndAuthorities.vue";
import BaseAvatar from "@/components/BaseAvatar";
import TitleWithSubheading from "@/components/TitleWithSubheading.vue";
import ProfileSubMenu from "../ProfileSubMenu";

export default defineComponent({
  name: "ProfileHeader",
  components: {
    ProfileSubMenu,
    TitleWithSubheading,
    BasePageTwoColumn,
    WrapperCheckAuthorities,
    WrapperCheckRoleAndAuthorities,
    BaseAvatar,
  },
  props: {
    user: { type: Object as () => User, required: true },
    hideDisable: { type: Boolean, default: false },
    hideDelete: { type: Boolean, default: false },
  },
  setup(props, { root }) {
    const loggedInUser = computed(() => root.$store.state.loggedInUser);
    const restrictedMember = computed(() => false);
    const featurePosts = computed(() => false);

    const setsLocation: ComputedRef<Location> = computed(() => {
      return {
        name: "profile/sets",
        params: {
          userId: props.user.id,
        },
      };
    });

    const userScreenName = computed(() =>
      props.user.accountInfo.disabled ? `${props.user.screenName} DISABLED` : props.user.screenName
    );

    const notMyPage = computed(() => !loggedInUser.value?.id || loggedInUser.value?.id !== props.user.id);

    return { loggedInUser, userScreenName, restrictedMember, featurePosts, setsLocation, notMyPage };
  },
});
